import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "rh_token";

export function saveToken(token) {
  if (token) {
    try { localStorage.setItem(TOKEN_KEY, token); } catch { /* storage unavailable */ }
  }
}
export function clearToken() {
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* storage unavailable */ }
}
export function getToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

export const api = axios.create({
  baseURL: API_BASE,
  // Auth is Bearer-token via `Authorization` header (see request interceptor
  // below) — we intentionally do NOT set withCredentials, so the edge/CDN
  // can return `Access-Control-Allow-Origin: *` without the browser rejecting
  // it (a credentialed request would require the exact origin echoed back,
  // which the Emergent edge can't guarantee when a custom domain is in use).
});

// Attach Bearer token from localStorage as a fallback for cross-origin
// setups where third-party cookies may be blocked (esp. mobile browsers).
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d?.msg ? d.msg : JSON.stringify(d))).join(" ");
  }
  // Structured backend errors — e.g. quota_exceeded from tier enforcement.
  if (detail?.message) return detail.message;
  if (detail?.msg) return detail.msg;
  return JSON.stringify(detail);
}

/**
 * If the API rejected the request because a subscription-tier limit was hit,
 * axios error → returns the structured quota info. Otherwise returns null.
 * Consumers can use this to render a targeted "Upgrade required" prompt.
 */
export function extractQuotaError(err) {
  const detail = err?.response?.data?.detail;
  if (err?.response?.status !== 402 || !detail || typeof detail !== "object") return null;
  if (detail.code !== "quota_exceeded") return null;
  return {
    limit_key: detail.limit_key,
    human_label: detail.human_label,
    current: detail.current,
    limit: detail.limit,
    message: detail.message,
  };
}
